const Component = {
  "图片 url 不存在": "Url imej tidak wujud",
  "暂不支持下载此类型图片": "Memuat turun imej jenis ini tidak disokong pada masa ini",
}

export default Component;